export default {
  button: {
    play: require("../assets/images/buttons/long_play.png"),
    back: require("../assets/images/buttons/back.png"),
    share: require("../assets/images/buttons/share.png"),
    long_play: require("../assets/images/buttons/long_play.png"),
    character: require("../assets/images/buttons/character.png"),
    camera: require("../assets/images/buttons/camera.png"),
    controller: require("../assets/images/buttons/controller.png"),
    shop: require("../assets/images/buttons/shop.png"),
    menu: require("../assets/images/buttons/menu.png"),
    settings: require("../assets/images/buttons/settings.png"),
    rank: require("../assets/images/buttons/rank.png"),
    social: require("../assets/images/buttons/social.png"),
    random: require("../assets/images/buttons/random.png"),
    mail: require("../assets/images/buttons/mail.png"),

    alerts: require("../assets/images/buttons/alerts.png"),
    conserve_battery: require("../assets/images/buttons/conserve_battery.png"),
    credits: require("../assets/images/buttons/credits.png"),
    facebook: require("../assets/images/buttons/facebook.png"),
    language: require("../assets/images/buttons/language.png"),
    mute: require("../assets/images/buttons/mute.png"),

    purchase: require("../assets/images/buttons/purchase.png"),
    shadows: require("../assets/images/buttons/shadows.png"),
    video_ads: require("../assets/images/buttons/video_ads.png"),

    left_button: require("../assets/images/buttons/left_button.png"),
    right_button: require("../assets/images/buttons/right_button.png"),

    select_button: require("../assets/images/buttons/select_button.png"),
  },
  title: require("../assets/images/title.png"),
  banner: require("../assets/images/characters/banner.png"),
  hand: {
    0: require("../assets/images/hand/0.png"),
    1: require("../assets/images/hand/1.png"),
  },

  particle: {
    fire: require("../assets/particles/fire_dark.png"),
    smoke: require("../assets/particles/smoke_dark.png"),
  },
};
